export default __webpack_public_path__ + "static/media/Logo_Notify360.6b4494c3.svg";